export default __webpack_public_path__ + "static/media/heartYellow.7f079904.svg";